var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-wrap"},[_c('common-head',{attrs:{"title":"关于"}}),_c('div',{staticClass:"content"},[_c('img',{staticClass:"app-icon",attrs:{"src":require("@/assets/images/logo.png")}}),_c('p',[_vm._v("版本号："+_vm._s(_vm.versionName))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }